import { BusinessTypeModel } from '../../business-type-model/business-type-model';
import { CountryList } from '../../dtos/register-form/country-list/country-list';

/**
 * Business data options for selects in form
 */
export class BusinessDataOptions {
  /**
   * @constructor
   */
  constructor(
    public country: CountryList[],
    public businessType: BusinessTypeModel[]
  ) {}
}
